import { IBackgroundJob } from './IBackgroundJob';
import { IGetItemsParams } from '../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';
import { Request } from '../../ts/ServerApi/requests/Request';

export interface IGetBackgroundJobsResult extends IGetItemsResult {
  backgroundJobs: IBackgroundJob[];
}

export class GetBackgroundJobsRequest extends Request<IGetItemsParams, IGetBackgroundJobsResult> {
  constructor(params: IGetItemsParams) {
    super('getBackgroundJobs', params);
  }
}
